@if (data) {
  <div class="status-text" fxLayout="row"
    fxLayoutAlign="start center">
    @if (data?.color) {
      <div class="status" [ngStyle]="{'background-color': data?.color }" [title]="data.title"></div>
    }
    <div class="text">{{data?.text }}</div>
  </div>
}
